import { useContext } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import SessionContext from '../contexts/SessionContext';

export type CredentialProvider = 'mitchell' | 'opstrax';

export interface SaveLocationCredentialsInput {
	organizationId: string;
	provider: CredentialProvider;
	credentials: Array<{
		locationId: string;
		username: string;
		password: string;
	}>;
}

interface GetLocationCredentialsResponse {
	credentials: Array<{
		locationId: string;
		locationTitle: string;
		username: string;
	}>;
}

export const useSaveLocationCredentials = () => {
	const sessionContext = useContext(SessionContext);
	return useMutation({
		mutationFn: async (input: SaveLocationCredentialsInput) => {
			const { data } = await axios.post(`${API_URL}/onboarding/location-credentials`, input, {
				headers: { Authorization: sessionContext?.sessionId ?? '' },
			});
			return data;
		},
	});
};

export const useGetLocationCredentials = (organizationId: string, provider: CredentialProvider) => {
	const sessionContext = useContext(SessionContext);
	return useQuery({
		queryKey: ['location-credentials', organizationId, provider],
		queryFn: async () => {
			const { data } = await axios.get<GetLocationCredentialsResponse>(
				`${API_URL}/onboarding/location-credentials`,
				{ params: { organizationId, provider }, headers: { Authorization: sessionContext?.sessionId ?? '' } }
			);
			return data.credentials;
		},
		enabled: Boolean(organizationId),
	});
};

